import { WithStatsForNerdsWebRenderer, updateDeviceCapabilities, getWebDeviceCapabilities, getDeviceCapabilities, getWebAdapters, WebAdapterName, } from '@zattoo/playback-sdk';
import { WithZapi, } from '@zattoo/playback-sdk-zapi';
import { Player } from '@zattoo/playback-sdk-react-native';
export const createPlayer = async (options) => {
    updateDeviceCapabilities(getWebDeviceCapabilities());
    const WebPlayerZapi = WithZapi(WithStatsForNerdsWebRenderer(Player));
    const playerAdapterName = options.playerAdapter ?? WebAdapterName.Shaka;
    const PlayerAdapter = await getWebAdapters()[playerAdapterName]();
    const player = new WebPlayerZapi(options, new PlayerAdapter.AdapterWithIma(options, getDeviceCapabilities));
    return Promise.resolve(player);
};
